import { createSelector } from 'reselect';
import { API_CALL_STATUS, FORM_STATUS } from '../../reducers/status';

export const getNaPersonalLoansCallMeBackState = (state) => state.publicWeb.naPersonalLoansCallMeBack;

export const getForm = createSelector(getNaPersonalLoansCallMeBackState, (state) => {
    return state.form;
});

const getFormField = (fieldId) => createSelector(getForm, (form) => form[fieldId]);

export const getIsFormValid = createSelector(
    getNaPersonalLoansCallMeBackState,
    (state) => state.formStatus === FORM_STATUS.VALID
);
export const getIsLeadSubmitted = createSelector(
    getNaPersonalLoansCallMeBackState,
    (state) => state.leadServiceStatus === API_CALL_STATUS.SUCCESS
);
export const getIsSideDrawerOpen = createSelector(getNaPersonalLoansCallMeBackState, (state) => state.isSidedrawerOpen);

export const getFirstNameValue = getFormField('firstName');
export const getSurnameValue = getFormField('surname');
export const getIdNumberValue = getFormField('idNumber');
export const getCellphoneNumberValue = getFormField('cellphoneNumber');
export const getTownValue = getFormField('town');
export const getEmploymentStatusValue = getFormField('employmentStatus');
export const getWageFrequencyValue = getFormField('wageFrequency');
export const getPayslipValue = getFormField('payslip');
export const getEmployerNameValue = getFormField('employerName');
export const getCreditCheckConsentValue = getFormField('creditCheckConsent');
